import { Typography } from '@mui/material';

import { darkBlue2 } from '@styles/colors';
import { medium } from '@styles/fontWeights';

const LocationBoostContent = () => (
  <Typography
    variant="h5"
    component="p"
    fontWeight={medium}
    color={darkBlue2}
    px={6}
  >
    We'll feature your jobs at the top of every job applicant search, at the top
    of all applicants "jobs near me" dashboard list within a 25 mile radius.
  </Typography>
);

export default LocationBoostContent;
